module.exports = __webpack_public_path__ + "static/media/diners.037da2d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/scrap-step/press/diners.png
// module id = 544
// module chunks = 0